import type RootStore from 'stores/RootStore'

import Navigation from './Navigation'

const initializeNavigation = (rootStore: RootStore) => new Navigation(rootStore)

export type { default as Navigation } from './Navigation'
export default initializeNavigation
